/**
 * Carousel Arrows - Arrow Navigation Controls
 * 
 * Provides arrow button controls for carousels
 */

document.addEventListener('DOMContentLoaded', function() {
    
    // Initialize all carousel-arrows instances
    document.querySelectorAll('.carousel-arrows').forEach(carouselArrows => {
        initCarouselArrows(carouselArrows);
    });

    function initCarouselArrows(carouselArrows) {
        const carouselId = carouselArrows.dataset.carouselId;
        const prevBtn = carouselArrows.querySelector('.carousel-arrows__prev');
        const nextBtn = carouselArrows.querySelector('.carousel-arrows__next');
        
        if (!prevBtn || !nextBtn) return;

        let currentSlide = 0;
        let totalSlides = 0;

        /**
         * Update arrow button states
         */
        function updateArrowStates() {
            if (prevBtn) {
                prevBtn.disabled = currentSlide === 0;
            }
            if (nextBtn) {
                nextBtn.disabled = currentSlide === totalSlides - 1;
            }
        }

        /**
         * Previous button click
         */
        prevBtn.addEventListener('click', () => {
            if (currentSlide > 0) {
                currentSlide--;
                
                // Dispatch custom event for carousel to listen to
                const event = new CustomEvent('carousel-nav-change', {
                    detail: {
                        carouselId: carouselId,
                        slideIndex: currentSlide,
                        direction: 'prev'
                    },
                    bubbles: true
                });
                carouselArrows.dispatchEvent(event);
                
                updateArrowStates();
            }
        });

        /**
         * Next button click
         */
        nextBtn.addEventListener('click', () => {
            if (currentSlide < totalSlides - 1) {
                currentSlide++;
                
                // Dispatch custom event for carousel to listen to
                const event = new CustomEvent('carousel-nav-change', {
                    detail: {
                        carouselId: carouselId,
                        slideIndex: currentSlide,
                        direction: 'next'
                    },
                    bubbles: true
                });
                carouselArrows.dispatchEvent(event);
                
                updateArrowStates();
            }
        });

        /**
         * Listen for external slide changes (e.g., from dots or swipe gestures)
         */
        document.addEventListener('carousel-slide-change', (e) => {
            if (e.detail.carouselId === carouselId) {
                currentSlide = e.detail.slideIndex;
                totalSlides = e.detail.totalSlides || totalSlides;
                updateArrowStates();
            }
        });

        /**
         * Listen for carousel initialization
         */
        document.addEventListener('carousel-init', (e) => {
            if (e.detail.carouselId === carouselId) {
                currentSlide = e.detail.currentSlide || 0;
                totalSlides = e.detail.totalSlides || 0;
                updateArrowStates();
            }
        });
    }
});
